export enum EditorModes {
  edit = 0,
  create = 1
}
